import { render, staticRenderFns } from "./TurnServers.vue?vue&type=template&id=1d3e63b3"
import script from "./TurnServers.vue?vue&type=script&lang=js"
export * from "./TurnServers.vue?vue&type=script&lang=js"
import style0 from "./TurnServers.vue?vue&type=style&index=0&id=1d3e63b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports